// extracted by mini-css-extract-plugin
module.exports = {"nav-panel":"lp","navPanel":"lp","nav-panel-bg":"lq","navPanelBg":"lq","nav-panel-content":"lr","navPanelContent":"lr","none":"ls","block":"lt"};